<template>
    <div class="evaluation-form-scoped">
        <p style="margin: 15px 0;">评分参考标准：<router-link :to="{path: '/scoreTips', query: {scoreType: scoreType,turn:turn}}"  target="_blank" class="el-button--text">点击查看</router-link></p>
        <el-form class="evaluation-form-scoped" label-width="200px" style="position:relative">
            <el-form-item label="评分标准" required>
                <el-input class="text-content" ref="score" placeholder="请按照参考评分标准，依次填写评分，如：124321" v-model="form.score"
                          @focus="showScoreTip=true"
                          :maxlength="9"
                          @blur="showScoreTip=false"></el-input>
            </el-form-item>
            <score-tips v-show="showScoreTip" :type="scoreType" :turn="turn" ></score-tips>
            <el-form-item label="是否通过" required>
                <el-radio-group v-model="form.userViewpoint" ref="userViewpoint">
                    <el-radio v-for="(item, index) in viewPointOptions" class="mr-20" :label="item.value" :key="index" v-if="item.value != '-1'">{{item.text}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="岗位建议方向"  required v-if="['18','19','20'].includes(scoreType) && advise.length">
                <el-checkbox-group v-model="form.hireAdvice" ref="hireAdvice">
                    <el-checkbox v-for="(item, index) in advise" class="mr-20" :label="item" :key="index">{{item}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="期望薪资" :required="form.userViewpoint !== '3' && form.userViewpoint!== '4'">
                <el-input class="text-content" placeholder="根据候选人实际要求填写即可，请尽可能详细；建议使用年薪作为填写内容" :maxlength="66" v-model="form.expectSalary" ref="expectSalary"></el-input>
            </el-form-item>
            <el-form-item label="面试记录" required>
                <el-input class="text-content" ref="interviewRecord" :maxlength="8000" placeholder="请输入面试问答详情" type="textarea" v-model="form.interviewRecord"></el-input>
            </el-form-item>
            <el-form-item label="综合评价" required >
                <el-input class="text-content" :maxlength="2000" placeholder="请输入评价内容" type="textarea" v-model="form.content" ref="content"></el-input>
            </el-form-item>
        </el-form>
        <society-form-tips v-if="false" :isSociety="true" :scoreType="scoreType" ></society-form-tips>
        <div class="button-footer">
            <el-button type="primary" @click="submit">提交评估</el-button>
            <el-button @click="cancel">取消</el-button>
        </div>
    </div>
</template>

<script>
    import SelectMapMixin from 'mixins/selectMapMixin'
    import SocietyBaseForm from './society-form-base'
    import ScoreTips from '../score-tips/score-tips.vue'
    import SocietyFormTips from './society-form-tips.vue'

    export default{
        mixins: [SelectMapMixin],
        extends: SocietyBaseForm,
        data () {
            return {
                showScoreTip: false,
                form: {
                    score: '',
                    hireAdvice: [],
                    userViewpoint: '',
                    expectSalary: '',
                    interviewRecord: '',
                    content: ''
                }
            }
        },
        props: {
            recruitType: null,
            isEdit: false,
            scoreType: null,
            extInfo: null,
            turn: null
        },
        components: {
            ScoreTips,
            SocietyFormTips
        }
    }
</script>
<style lang="scss">
    @import "../evaluation-form";
</style>


// WEBPACK FOOTER //
// society-form-2021-qa.vue?e1260460